(function () {
    "use strict";

    // @ngInject
    function NetworkProjectControllerCtor($scope, $injector, $stateParams, $location, $anchorScroll,
                                          UsersManager, NetworkManager, NetworkService,
                                          AnalyticsService, CompanyService, PopupMessageService, Gon) {

        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'NetworkProjectController';
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        this.projectId = $stateParams.project_id;
        this.openShareProject = $stateParams.share;
        this.UsersManager = UsersManager;
        this.NetworkManager = NetworkManager;
        this.NetworkService = NetworkService;
        this.PopupMessageService = PopupMessageService;
        this.AnalyticsService = AnalyticsService;
        this.currUser = this.NetworkManager.getNetworkCurrUser();
        var trackingData = {};
        this.alreadyGotProject = false;
        this.deleting = false;
        this.vendorTypeTranslationMap = CompanyService.getCompanyTypesTranslationMap();
        this.projectType = "network_project";
        this.base_url = Gon.url;

        // If project id has been provided, fetch the user or redirect to my profile
        if(this.projectId) {
            trackingData.projectId = this.projectId;
            this.project = this.NetworkManager.getProject(this.projectId);

            this.project.on('success', function () {
                this.gotProject();
            }.bind(this));

            this.project.on('error', function () {
                if (this.alreadyGotProject) {
                    return;
                }

                var message = 'NETWORK._UNABLE_TO_LOAD_MESSAGE_';
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, message, function success() {
                    this.goToState(this.AppStates.root_network_feed_projects);
                }.bind(this));
            }.bind(this));
        }

        this.AnalyticsService.trackPageView(this, 'network project', trackingData);
    }

    Controllers.NetworkProjectController = Class(Controllers.BaseController, {

        constructor: NetworkProjectControllerCtor,

        gotProject: function gotProject(){
            this.alreadyGotProject = true;
            this.isEditable = this.currUser._id === this.project.creator._id;
            this.publicProjectUrl = this.getPublicProjectUrl();
        },

        openNetworkTagVendors: function openNetworkTagVendors() {
            this.NetworkService.tagNetworkVendors(this.project);
        },

        deleteProject: function deleteProject() {

            var self = this;

            var deleteConfirmed = function deleteConfirmed(){

                self.deleting = true;
                self.analyticsArgs = {
                    projectId : self.project._id
                };

                self.NetworkManager.deleteNetworkProject(self.currUser, self.project._id).then(
                    function success() {
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.network_deleted_project, self.analyticsArgs);
                    },
                    function error() {
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.network_deleted_project_error, self.analyticsArgs);
                    }
                ).finally(function done() {
                    self.deleting = false;
                    self.goToState(self.AppStates.root_network_my_profile);
                });
            };

            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                'NETWORK.PROJECT._CONFIRM_DELETE_',
                deleteConfirmed);
        },

        goToAddComment: function goToAddComment(){
            this.$location.hash('proj-comments-header');
            this.$anchorScroll();
        },

        getPublicProjectUrl: function getPublicProjectUrl() {
            if(this.project && this.project.unique_project_name) {
                return this._getPublicProjectsBaseUrl() + 'project/' + this.project.unique_project_name;
            } else if(this.projectId) {
                return this._getPublicProjectsBaseUrl() + 'project/' + this.projectId;
            }
        },

        _getPublicProjectsBaseUrl: function getPublicProjectsBaseUrl() {

            // get url of react app
            var publicProjectsBaseUrl = this.base_url;
            if(this.base_url.indexOf('staging') !== -1) {
                publicProjectsBaseUrl = 'https://hb-public-community-staging.herokuapp.com/';
            } else if(this.base_url.indexOf('localhost') !== -1) {
                publicProjectsBaseUrl = 'http://localhost:4000/';
            }
            return publicProjectsBaseUrl;
        },

        canDeleteContributor: function canDeleteContributor(contributor) {
            return (this.UsersManager.isCurrentUser(contributor._id) &&
                contributor._id !== this.project.creator._id);
        },

        deleteContributor: function deleteContributor(contributor, event) {
            event.preventDefault();
            event.stopPropagation();

            var index = this.project.member_ids.indexOf(contributor._id);
            if (index <= -1) {
               return;
            }

            this.project.member_ids.splice(index, 1);
            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                'Are you sure you want to remove ' + contributor.network.full_name + ' as a collaborator?',
                function ok() {
                    this.NetworkManager.updateNetworkProjectMembers(this.project, this.project.member_ids).then(
                        function success(){
                            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_edit_project, {projectId: this.project._id});
                        }.bind(this),
                        function error(resp){
                            this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_edit_project, resp);
                        }.bind(this));
                }.bind(this),
                function cancelled(){

                },
                'Remove',
                'Cancel');
        }

    });
}());
